<template>
  <div class="d-flex flex-column">
    <el-dialog
      top="2vh"
      v-if="replaceBadWord.show"
      :title="'Tin nhắn gửi đi có chứa ' + replaceBadWord.items.length + ' từ khóa nhạy cảm'"
      width="500px"
      :visible.sync="replaceBadWord.show"
      :close-on-click-modal="false"
      :destroy-on-close="true">
      <div>
        <div>
          <div class="d-flex fw-bolder font-size-14 mb-3">
            <div class="w-150px">Từ cấm</div>
            <div class="flex-1">Từ thay thế</div>
            <div style="width: 60px"></div>
          </div>
          <div class="divider-custom"></div>
          <div style="max-height: 200px; overflow-y: auto">
            <div
              v-for="(item, index) in replaceBadWord.items"
              :key="index">
              <div class="d-flex font-size-14 my-2">
                <div class="w-150px">
                  <div class="d-flex">
                    <div class="">{{ item.key }}</div>
                  </div>
                </div>
                <div class="flex-1">
                  <el-input
                    placeholder="Nội dung thay thế"
                    @input="handleInputReplace(item)"
                    v-model="item.replace"></el-input>
                </div>
              </div>
              <div class="divider-custom"></div>
            </div>
          </div>
        </div>
        <div class="my-2">Nội dung sau chỉnh sửa</div>
        <el-input
          ref="inputText"
          resize="none"
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 5 }"
          v-model="replaceBadWord.content"
          disabled />
        <div class="d-flex justify-content-end mt-2">
          <el-button
            size="sm"
            plain
            type="danger"
            @click="closeReplaceBadWord()">
            Hủy
          </el-button>
          <el-button
            size="sm"
            type="primary"
            @click="sendReplace()">
            Gửi tin nhắn
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      v-if="isShowProfile"
      :visible.sync="isShowProfile"
      top="40px"
      width="360px"
      :destroy-on-close="true">
      <ProfileInfoPopup :conversation="{ toId: toId, accountId: conversation.accountId }" />
    </el-dialog>
    <el-dialog
      v-if="showImageLibrary"
      :visible.sync="showImageLibrary"
      :close-on-click-modal="false"
      top="40px"
      :destroy-on-close="true">
      <ImageLibraryPopup
        :conversation="conversation"
        @closeImagePopup="showImageLibrary = false"
        @eventSendPhoto="sendMsgPhoto" />
    </el-dialog>
    <el-dialog
      v-if="showMessageShare"
      title="Chia sẻ"
      width="520px"
      :visible.sync="showMessageShare"
      :close-on-click-modal="false"
      :destroy-on-close="true">
      <SharePopup
        :message="messageShare"
        :selectConversation="conversation"
        :message-list="messageList"
        @closeSharePopup="showMessageShare = false" />
    </el-dialog>
    <el-dialog
      v-if="createTopic"
      :visible.sync="createTopic"
      :close-on-click-modal="false"
      title="Tạo nhắc hẹn"
      :destroy-on-close="true"
      width="400px">
      <div class="flex-column">
        <el-input
          ref="inputText"
          type="textarea"
          resize="none"
          :rows="3"
          placeholder="Nhập nội dung mới"
          v-model="topic.title" />
        <div class="my-2">Chọn thời gian :</div>
        <el-date-picker
          v-model="topic.startTime"
          type="datetime"
          class="w-100"
          placeholder="Chọn ngày nhắc hẹn"></el-date-picker>
        <div class="my-2">Chọn kiểu lặp lại :</div>
        <el-select
          v-model="topic.repeat"
          class="w-100">
          <el-option
            v-for="(item, index) in repeatType"
            :key="index"
            :label="item.name"
            :value="item.val"></el-option>
        </el-select>
        <div class="d-flex mt-3 justify-content-end">
          <el-button
            type="danger"
            plain
            @click="createTopic = false">
            Hủy
          </el-button>
          <el-button
            type="primary"
            plain
            @click="createNewTopic()">
            Tạo nhắc hẹn
          </el-button>
        </div>
      </div>
    </el-dialog>
    <MessageBoxHeader
      ref="boxHeader"
      :countMember="getCount()"
      :conversation="conversation"
      :avatar="conversation.avatar"
      :toName="conversation.toName"
      :online="false"
      :lastOnlineStr="''"
      :idConversationGroup="conversation"
      :members="members"
      :pin="conversation.isPin" />
    <PinMessages
      ref="pinComponents"
      :conversation="conversation"
      :pin-messages="pinMessages"
      @createOverScreen="createOverScreen()"
      @removeOverScreen="removeOverScreen()" />

    <div
      class="flex-grow-1"
      style="background-color: #ececec !important">
      <div
        class="chat-conversation"
        data-simplebar="init"
        ref="chatConversation">
        <div
          class="simplebar-wrapper"
          element-loading-text="Đang tải dữ liệu..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="#f5f5f5">
          <div class="simplebar-height-auto-observer-wrapper">
            <div class="simplebar-height-auto-observer"></div>
          </div>
          <div class="simplebar-mask">
            <div class="simplebar-offset">
              <div
                class="simplebar-content-wrapper-message"
                id="message-list"
                ref="scrollContainer"
                @scroll="onScroll">
                <div
                  v-if="canLoadMore"
                  class="loadingMore">
                  <ImageLoading
                    :type="'spin'"
                    :color="'#50a5f1'" />
                </div>
                <div class="simplebar-content">
                  <div
                    class="sentinel"
                    ref="sentinel"></div>

                  <div
                    v-for="(message, index) in messageList"
                    :key="message.newIdMessage != undefined ? message.newIdMessage : index">
                    <div v-if="message.msgType !== 'chat.delete' && message.msgType !== 'chat.undo' && message.showPt">
                      <li :class="message.id.uidFrom == '0' ? 'right d-block' : 'left d-block'">
                        <div
                          class="conversation-list"
                          :class="[{ 'flex-row-reverse': message.id.uidFrom != '0' }, message.id.uidFrom === '0' && message.isActionMessage ? 'w-100' : '']"
                          v-bind:style="message.isActionMessage ? 'display:block' : ''">
                          <div
                            class="user-chat-content d-flex"
                            style="position: relative"
                            v-bind:style="message.isActionMessage ? 'display: block !important' : ''">
                            <div
                              class="ctext-wrap"
                              v-bind:style="message.isActionMessage ? 'display: block !important' : ''">
                              <MessageContent
                                :is-group="true"
                                :message="message"
                                :message-list="messageList"
                                :key="message.id.msgId"
                                :send-by-list="sendByList"
                                :replace-url="replaceUrl"
                                :conversation-id="conversation.id"
                                :account-id="conversation.accountId"
                                style="word-break: break-word"
                                :members="members"
                                v-bind:style="!message.isActionMessage ? 'max-width: 500px' : ''" />
                            </div>
                            <GroupMessageAction
                              :message="message"
                              @showRepliedMessage="showRepliedMessage"
                              @showMessageSharePopup="showMessageSharePopup"
                              @copy="copy"
                              @dowloadImage="dowloadImage"
                              @undoMessage="undoMessage"
                              @pinMessage="pinMessage" />
                          </div>
                          <el-avatar
                            v-if="!message.isActionMessage"
                            @click.native.stop="openProfile(message)"
                            :src="getMember(message.id.uidFrom != '0' ? message.id.uidFrom : conversation.accountId).avatar"
                            class="pointer"
                            style="min-width: 24px; min-height: 24px; max-width: 24px; max-height: 24px"
                            v-bind:style="message.id.uidFrom == '0' ? 'margin: 0px 4px 10px 4px' : 'margin: 4px 4px 10px 4px'" />
                        </div>
                      </li>
                    </div>
                  </div>
                  <div>
                    <li
                      v-if="loadingImage"
                      class="right d-block">
                      <div class="conversation-list">
                        <div class="user-chat-content">
                          <div class="ctext-wrap">
                            <ImageLoading
                              :type="'bubbles'"
                              :color="'#808080'" />
                          </div>
                        </div>
                      </div>
                    </li>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="position-relative">
          <div
            v-if="showIconNewMessage"
            @click="handleIconNewMessage()"
            class="position-absolute pointer fw-semibold rounded-2 btn-jump">
            <span>
              <i
                class="el-icon-d-arrow-left ms-1 me-1 align-self-end"
                style="rotate: -90deg"></i>
            </span>
            Có tin nhắn mới
          </div>
        </div>
      </div>
    </div>
    <div class="position-relative">
      <LinkPopup
        v-if="!showReplied && showLink"
        :data="linkObject"
        @closeLinkPopup="showLink = false" />
    </div>
    <MessageBoxTags
      :conversation="conversation"
      :tags="tags" />
    <div style="margin-bottom: 2px"></div>
    <el-popover
      transition="el-fade-in-linear"
      v-model="showMention"
      :visible-arrow="false"
      placement="top-start"
      width="300"
      trigger="click">
      <div
        class="overflow-auto"
        style="height: 400px; max-height: 400px">
        <div
          :key="index"
          v-for="(item, index) in itemsInMention">
          <div
            class="pointer pin d-flex rounded-1 align-items-center py-2 px-1"
            @click="addMentioned(item)">
            <el-avatar
              class="mx-2"
              :src="item.avatar"
              v-if="item.id != '-1'"
              style="min-width: 32px; min-height: 32px; max-width: 32px; max-height: 32px" />
            <div
              class="d-flex align-items-center"
              v-else>
              <el-avatar
                class="mx-2"
                src="https://chat.zalo.me/assets/icn_mentionall.b2c245e08bb8372941a2ae03865b67e4.png"
                style="min-width: 32px; min-height: 32px; max-width: 32px; max-height: 32px" />
              <div class="me-2">Báo cho cả nhóm</div>
            </div>

            <div
              v-bind:class="item.id === '-1' ? 'c-blue' : ''"
              class="me-2">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div slot="reference"></div>
    </el-popover>
    <div
      ref="chatMessageReply"
      v-if="showReplied && showChat"
      class="mx-1 rounded-3 d-flex p-1"
      style="position: relative; background-color: #eaedf0">
      <img
        :src="hoveredReplied === 1 ? iconCloseFill : iconClose"
        @mouseover="hoveredReplied = 1"
        @mouseleave="hoveredReplied = null"
        @click="closeReplied()"
        class="pointer"
        style="width: 15px; height: 15px; position: absolute; top: 6px; right: 6px" />
      <div class="divider-right ms-2"></div>
      <div class="ms-2 d-flex flex-column justify-content-around">
        <div
          class=""
          style="">
          Trả lời
          <span class="fw-bolder">{{ conversation.toName }}</span>
        </div>
        <MessageContent
          class="text-blur"
          :messageRepied="true"
          :message-list="messageList"
          :message="messageReplied"
          :conversation-id="conversation.id" />
      </div>
    </div>
    <div
      ref="inputText"
      v-if="isLockSendMsg() && showChat"
      class="msg-input d-flex align-items-center p-1 d-flex justify-content-center w-100 align-items-center font-size-16">
      <i
        style="color: #0068ff"
        class="el-icon-warning-outline me-2" />
      <div>
        Chỉ
        <span style="color: #0068ff">trưởng/phó nhóm</span>
        được gửi tin nhắn vào nhóm.
        <a
          href="https://help.zalo.me/huong-dan/chuyen-muc/tro-chuyen-nhom/tai-sao-ban-khong-the-nhan-tin-trong-mot-so-nhom-zalo/"
          target="_blank">
          Tìm hiểu thêm
        </a>
      </div>
    </div>
    <div
      v-if="!isLockSendMsg() && isRemove && showChat"
      class="msg-input d-flex align-items-center p-1">
      <p
        class="mx-auto"
        style="font-size: 16px; color: red">
        Bạn đã rời khỏi nhóm này!
      </p>
    </div>
    <div
      v-if="!isLockSendMsg() && !isRemove && showChat"
      class="msg-input d-flex align-items-center p-1">
      <div
        class="flex-grow-1 text-center"
        @drop="dropHandler">
        <el-input
          ref="inputText"
          type="textarea"
          resize="none"
          placeholder="Nhập tin nhắn hoặc gõ / để chọn mẫu tin..."
          @keydown.enter.exact.native="sendMessage"
          v-model="newMessage"
          :autosize="{ minRows: 2, maxRows: 3 }"
          @input="handleInput"
          v-debounce:10ms.lock="checkTyping"
          v-debounce:500ms.unlock="unlockTyping" />
      </div>
      <div class="mx-1 d-flex align-items-center">
        <div v-show="!newMessage">
          <div class="d-flex">
            <li
              class="list-inline-item"
              style="margin-right: 0"
              data-bs-toggle="tooltip"
              title="Thư viện">
              <el-button
                @click="showImageLibrary = true"
                style="border: none; margin-left: 0"
                class="p-1 pointer rounded-1 pin flex-1 icon-image font-size-18" />
            </li>
            <li
              class="list-inline-item"
              style="margin-right: 0px"
              title="Tải ảnh lên">
              <input
                style="display: none; width: 0; height: 0"
                ref="file"
                type="file"
                multiple
                @change="fileSelected" />
              <el-button
                @click="$refs.file.click()"
                style="border: none; margin-left: 0"
                class="p-1 pointer rounded-1 pin flex-1 icon-attach font-size-18" />
            </li>
            <li
              class="list-inline-item"
              style="margin-right: 0"
              title="Nhắc hẹn">
              <el-button
                slot="reference"
                @click="showCreatePopup()"
                style="border: none; margin-left: 0"
                class="p-1 pointer rounded-1 pin flex-1 icon-clock font-size-18" />
            </li>
          </div>
        </div>
        <li
          class="list-inline-item"
          style="margin-right: 0"
          title="Nhãn dán">
          <el-popover
            placement="top"
            trigger="click"
            v-model="stickerVisible">
            <el-button
              slot="reference"
              style="border: none; margin-left: 0"
              class="p-1 pointer pin rounded-1 icon-smile font-size-18 flex-1" />
            <EmojiPicker />
          </el-popover>
        </li>
        <li
          class="list-inline-item"
          style="margin-right: 0px"
          title="Mẫu tin">
          <el-popover
            v-model="showQuickMessage"
            placement="top-end"
            width="350"
            trigger="click">
            <QuickReplyPopup
              @selectedMessage="selectMessage"
              :content="newMessage" />
            <el-button
              slot="reference"
              style="border: none; margin-left: 0"
              class="p-1 pointer rounded-1 pin flex-1 flex-1 icon-mess font-size-18" />
          </el-popover>
        </li>
        <el-button
          style="border: none; margin-left: 0"
          v-bind:class="app.expandMessage ? 'pe-3' : ''"
          class="p-1 pointer rounded-1 pin flex-1 d-flex align-items-center justify-content-center">
          <img
            src="/assets/icon/send.svg"
            class="font-size-20"
            @click="sendMessage" />
          <!--          <div type="primary" class="" style="border: 1px solid #0068ff;color: #0068ff;margin-bottom: 0" @click="sendMessage">GỬI</div>-->
        </el-button>
      </div>
    </div>
    <div
      v-if="app.selectedImages.length > 0 && showChat"
      class="d-flex ms-1 flex-wrap"
      v-bind:style="{ height: HEIGHT_MESSAGE_PASTE + 'px', overflow: 'auto' }"
      style="margin-bottom: 0px">
      <div
        style="margin-right: 10px; margin-bottom: 10px; width: 70px; height: 70px; position: relative"
        v-for="(image, index) in app.selectedImages"
        :key="index">
        <div v-if="image.file">
          <el-image
            v-if="image.file.type.startsWith('image/')"
            class="rounded-2"
            style="width: 70px; height: 70px"
            :src="image.url"
            fit="cover"
            lazy></el-image>
          <div
            v-else
            style="width: 70px; height: 70px">
            <el-image
              style="width: 50px; height: 50px; margin-left: 10px"
              :src="source ? source : 'https://chat.zalo.me/assets/icon-file-empty.6796cfae2f36f6d44242f7af6104f2bb.svg'"
              fit="cover"
              lazy></el-image>
            <el-tooltip
              slot="reference"
              effect="dark"
              :content="image.file.name"
              placement="top">
              <div style="width: 70px; height: 20px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; cursor: pointer; font-weight: bold">
                {{ image.file.name }}
              </div>
            </el-tooltip>
          </div>
        </div>
        <el-image
          v-else
          class="rounded-2"
          style="width: 70px; height: 70px"
          :src="image.url"
          fit="cover"
          lazy></el-image>
        <img
          :src="hovered === index ? iconCloseFill : iconClose"
          @mouseover="hovered = index"
          @mouseleave="hovered = null"
          @click="removeImage(index)"
          class="pointer"
          style="width: 15px; height: 15px; position: absolute; top: 4px; right: 2px" />
      </div>
    </div>
    <div
      v-if="!showChat"
      class="d-flex justify-content-center">
      <div class="">Tài khoản bị ngắt kết nối với Salework</div>
    </div>
  </div>
</template>

<script>
import GroupMessageAction from "./GroupMessageAction.vue";
import MessageContent from "./message/MessageContent";
import MessageBoxHeader from "./message/MessageBoxHeader";
import MessageBoxTags from "./message/MessageBoxTags";
import ImageLoading from "./message/ImageLoading";
import ImageLibraryPopup from "./ImageLibraryPopup";
import SharePopup from "./message/SharePopup";
import LinkPopup from "./message/LinkPopup";
import PinMessages from "./message/PinMessages";
import { COMMON } from "../lib/Common";
import ProfileInfoPopup from "./ProfileInfoPopup";
import EmojiPicker from "./message/EmojiPicker";

export default {
  props: ["conversation", "showChat"],
  components: {
    EmojiPicker,
    ProfileInfoPopup,
    PinMessages,
    LinkPopup,
    SharePopup,
    ImageLibraryPopup,
    ImageLoading,
    MessageBoxTags,
    MessageBoxHeader,
    MessageContent,
    GroupMessageAction,
    QuickReplyPopup: () => import("../components/QuickReplyPopup"),
  },
  watch: {
    pinMessages(newValue, oldvalue) {
      this.calculatorPinMessageHeight(newValue, oldvalue);
    },
    imageSelecteds: function () {
      this.calculatorHeightMessage();
    },
  },
  computed: {
    filterCharacterArr() {
      const characterArr = this.app.characterFilters;
      const arrCommon = characterArr["0"];
      const arrOnwerAccount = characterArr[this.conversation.accountId];
      let array = [];
      if (arrCommon && arrCommon.length > 0) {
        array.push(...arrCommon);
      }
      if (arrOnwerAccount && arrOnwerAccount.length > 0) {
        array.push(...arrOnwerAccount);
      }
      const key = "content";
      const unique = [...new Map(array.map((item) => [item[key], item])).values()];
      return unique;
    },
    imageSelecteds() {
      return this.app.selectedImages;
    },

    itemsInMention() {
      let index = this.members.findIndex((s) => s.id == "-1");
      let response = JSON.parse(JSON.stringify(this.members));
      if (index === -1) {
        let item = { id: "-1", name: "All" };
        response.unshift(item);
      }
      if (this.searchTextMention !== null) {
        let arr = response.filter((s) => {
          if (this.searchTextMention.length === 0) return true;
          return s.name.toLowerCase().includes(this.searchTextMention.toLowerCase());
        });
        if (arr.length === 0) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.showMention = false;
        }
        if (this.listMentions.length > 0) {
          return arr.filter((s) => !this.listMentions.map((t) => t.uid).includes(s.id));
        }
        return arr;
      } else {
        if (this.listMentions.length > 0) {
          return response.filter((s) => !this.listMentions.map((t) => t.uid).includes(s.id));
        }
        return response;
      }
    },
  },
  data() {
    return {
      toId: 0,
      isShowProfile: false,
      settingGroup: {
        addMemberOnly: 0,
        banDuration: 0,
        bannFeature: 0,
        blockName: 0,
        dirtyMedia: 0,
        enableMsgHistory: 1,
        joinAppr: 0,
        lockCreatePoll: 0,
        lockCreatePost: 0,
        lockSendMsg: 0,
        lockViewMember: 0,
        setTopicOnly: 0,
        signAdminMsg: 1,
        adminIds: [],
      },
      isRemove: false,
      mentionItems: [],
      showIconNewMessage: false,
      messageReplied: {},
      visiblePopup: false,
      pinMessages: [],
      showLink: false,
      linkObject: {},
      messageShare: {},
      showMessageShare: false,
      hoveredReplied: null,
      HEIGHT_MESSAGE_REPLIED: 60,
      HEIGHT_MESSAGE_PASTE: 75,
      showReplied: false,
      showMessagePaste: false,
      hovered: null,
      iconClose: "/assets/icon/icon_close.svg",
      iconCloseFill: "/assets/icon/icon_close_fill.svg",
      canLoadMore: true,
      PAGE_SIZE: 30,
      messageList: [],
      newMessage: "",
      members: [],
      stickerVisible: false,
      tags: [],
      showQuickMessage: false,
      loadingImage: false,
      showImageLibrary: false,
      typing: false,
      sendByList: [],
      replaceUrl: [],
      reactionList: [],
      createTopic: false,
      topic: {},
      repeatType: [
        { name: "Không lặp lại", val: 0 },
        { name: "Hàng ngày", val: 1 },
        { name: "Hàng tuần", val: 2 },
        { name: "Hàng tháng", val: 3 },
      ],
      showMention: false,
      listMentions: [],
      searchTextMention: null,
      replaceBadWord: {
        show: false,
        items: [],
        content: "",
      },
    };
  },

  methods: {
    openProfile(message) {
      if (message.id.uidFrom == "0") return;
      this.toId = message.id.uidFrom;
      this.isShowProfile = true;
    },
    createNewMessageFile(cliMsgId) {
      let message = {};
      let id = (message.id = {});
      id.conversationId = this.conversation.id;
      id.idTo = this.conversation.toId;
      id.msgId = new Date().getTime().toString();
      id.uidFrom = "0";
      message.cliMsgId = cliMsgId;
      message.msgType = COMMON.LOADING_FILE;
      message.ts = new Date().getTime().toString();
      return message;
    },
    removeLoadingFile(cliMsgId) {
      let index = this.messageList.findIndex((s) => s.cliMsgId === cliMsgId && s.msgType === COMMON.LOADING_FILE);
      if (index > -1) {
        this.messageList.splice(index, 1);
      }
    },
    isShowUndoIcon(message) {
      return !this.isPhotoGroup(message) && message.cliMsgId != null && !this.isActionMessage(message) && message.id.uidFrom === "0";
    },
    async sendFile(file, bodyFormData) {
      let cliMsgId = new Date().getTime();
      try {
        let message = this.createNewMessageFile(cliMsgId);
        message.fileName = file.name;
        message.size = file.size;
        message.contentType = file.type;
        this.messageList.push(message);
        this.sortMessage("new");
        // this.messageList = this.messageList.sort((a, b) => Number(a.ts) - Number(b.ts));
      } catch (e) {
        this.removeLoadingFile(cliMsgId);
      }
      try {
        await this.$http.post("/api/message/sendMsgFile", bodyFormData);
      } finally {
        this.removeLoadingFile(cliMsgId);
      }
    },
    isShowListIcon(message) {
      return (
        (message.msgType === "webchat" ||
          this.isLinkMessage(message) ||
          message.msgType === "chat.photo" ||
          message.msgType === COMMON.CHAT_VIDEO ||
          message.msgType === COMMON.CHAT_FILE ||
          this.isCardBusiness(message)) &&
        message.cliMsgId != null &&
        !this.isActionMessage(message)
      );
    },
    isShowReplyIcon(message) {
      return (
        this.isShowListIcon(message) &&
        (message.msgType === "webchat" ||
          this.isLinkMessage(message) ||
          (message.msgType === "chat.photo" && message.cliMsgId != null && this.isPhotoGroup(message) === false))
      );
    },
    getLastKeyBeforeCaret(caretIndex) {
      let _this = this.newMessage;
      const [keyData] = ["@"]
        .map((key) => ({
          key,
          keyIndex: _this.lastIndexOf(key, caretIndex - 1),
        }))
        .sort((a, b) => b.keyIndex - a.keyIndex);
      return keyData;
    },
    getSelectionStart() {
      return this.newMessage.length;
    },
    restoreMention() {
      this.showMention = false;
      this.searchTextMention = null;
    },
    async dowloadImage(message) {
      let groupLayoutId = JSON.parse(JSON.parse(message.content).params).group_layout_id;
      if (groupLayoutId === undefined) {
        let url = JSON.parse(message.content).href;
        this.dowload(url);
        this.alert("success", "Tải ảnh về thành công!");
        return;
      }
      let photos = [];
      let filter = this.messageList.filter((p) => p.msgType == "chat.photo");
      filter.forEach((item) => {
        let params = JSON.parse(JSON.parse(item.content).params);
        if (params.is_group_layout) {
          if (params.group_layout_id == groupLayoutId) {
            photos.push({ id: params.id_in_group, url: this.findUrlHDIfExist(item.content) });
          }
        }
      });
      photos.forEach((item) => {
        this.dowload(item.url);
      });
      if (photos.length > 0) {
        this.alert("success", "Tải ảnh về thành công!");
        return;
      }
      this.alert("error", "Tải ảnh về thất bại!");
    },
    dowload(url) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const objectUrl = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = objectUrl;
          link.download = url;
          document.body.appendChild(link);
          link.click();

          URL.revokeObjectURL(objectUrl);
        });
    },

    findUrlHDIfExist(content) {
      try {
        let linkHD = JSON.parse(JSON.parse(content).params).hd;
        if (linkHD !== null && linkHD !== undefined) {
          return linkHD;
        }
      } catch (ex) {
        // Ignore
      }
      return JSON.parse(content).href;
    },

    addMentioned(item) {
      let hintLens = this.searchTextMention.length;
      this.newMessage = this.newMessage.substring(0, this.newMessage.length - hintLens);
      this.newMessage = this.newMessage + item.name + " ";
      this.restoreMention();
      if (this.showChat) {
        this.$refs.inputText.focus();
      }
      let mention = {};
      mention.name = item.name;
      mention.uid = item.id;
      this.listMentions.push(mention);
    },
    mentioned() {
      let req = {
        accountId: this.conversation.accountId,
        groupId: this.conversation.toId,
        message: this.newMessage,
        mentions: this.listMentions,
      };
      this.newMessage = "";
      this.$http
        .post("/api/message/group/mention", req)
        .then()
        .finally(() => {
          this.listMentions = [];
        });
    },

    refactorListMentions() {
      // let name = this.listMentions.map(s => "@" + s.name);
      let arr = [];
      arr = this.listMentions.reduce((t, v) => {
        let name = "@" + v.name;
        if (this.newMessage.includes(name)) {
          let obj = {};
          let index = this.newMessage.indexOf(name);
          obj.name = name;
          obj.uid = v.uid;
          obj.pos = index;
          obj["length"] = name.length;
          return [...t, obj];
        } else {
          return [...t];
        }
      }, []);
      this.listMentions = arr;
      return this.listMentions;
    },
    getLastSearchText(caretIndex, keyIndex) {
      if (keyIndex !== -1) {
        const searchText = this.newMessage.substring(keyIndex + 1, caretIndex);
        // If there is a space we close the menu
        if (!/\s/.test(searchText)) {
          return searchText;
        }
      }
      return null;
    },
    getMentionComponent() {
      const index = this.getSelectionStart();
      if (index >= 0) {
        const { keyIndex } = this.getLastKeyBeforeCaret(index);
        const searchText = this.getLastSearchText(index, keyIndex);
        if (!(keyIndex < 1 || /\s/.test(this.newMessage[keyIndex - 1]))) {
          return (this.showMention = false);
        }
        if (searchText != null) {
          this.searchTextMention = searchText;
          this.showMention = true;
        } else {
          this.restoreMention();
        }
      }

      // this.showMention = ("@" === this.newMessage.charAt(0) && this.newMessage.length === 1) || (this.newMessage.substr(this.newMessage.length - 1) === "@" && this.newMessage.substr(this.newMessage.length - 2) === " @");
      //
    },
    calculatorPinMessageHeight(newValue, oldvalue) {
      if (this.pinMessages.length > 0 && newValue === undefined && oldvalue === undefined)
        return (this.$refs.chatConversation.style.height = `calc( ${this.$refs.chatConversation.style.height} - 52px)`);
      if (newValue === undefined) return;
      if (newValue.length > 0 && oldvalue.length === 0)
        return (this.$refs.chatConversation.style.height = `calc( ${this.$refs.chatConversation.style.height} - 52px)`);
      if (newValue.length === 0 && oldvalue.length > 0)
        return (this.$refs.chatConversation.style.height = `calc( ${this.$refs.chatConversation.style.height} + 52px)`);
    },
    onScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (Math.abs(scrollHeight - clientHeight - scrollTop) < 1) {
        this.showIconNewMessage = false;
      }
    },
    createOverScreen() {
      this.$refs.chatConversation.style.opacity = "0.2";
    },
    removeOverScreen() {
      this.$refs.chatConversation.style.opacity = "1";
    },

    scrollImmediately() {
      this.$nextTick().then(() => {
        let scrollContainer = this.$refs["scrollContainer"];
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: "smooth",
        });
      });
    },
    handleIconNewMessage() {
      this.showIconNewMessage = false;
      this.scrollImmediately();
    },
    sortMessage(type, clientMsgId) {
      if (clientMsgId) {
        let messageFt = this.messageList.filter((p) => p.cliMsgId == clientMsgId);
        if (messageFt != null && messageFt.length > 0) {
          let undoList = this.messageList.filter((m) => m.msgType == "chat.delete" || m.msgType == "chat.undo");
          let filter = this.messageList.filter((p) => p.msgType == "chat.photo");
          let newMes = this.parseMessage(messageFt[0], "new", undoList, filter);
          let index = this.messageList.indexOf(messageFt[0]);
          if (index > -1) {
            this.messageList.splice(index, 1);
          }
          this.messageList.push(newMes);
        }
      } else {
        let undoList = this.messageList.filter((m) => m.msgType == "chat.delete" || m.msgType == "chat.undo");
        let filter = this.messageList.filter((p) => p.msgType == "chat.photo");
        this.messageList.map((message) => {
          return this.parseMessage(message, type, undoList, filter);
        });
      }
      this.messageList = this.messageList.sort((a, b) => Number(a.ts) - Number(b.ts));
    },
    isShowThreeDot(message) {
      return !this.isActionMessage(message) && message.msgType !== "chat.undo" && message.msgType !== "chat.delete";
    },
    isPhotoGroup(message) {
      try {
        if (message.msgType == "chat.photo") {
          if (JSON.parse(message.content).params) {
            let params = JSON.parse(JSON.parse(message.content).params);
            if (params.is_group_layout) {
              return true;
            }
          }
        }
      } catch (e) {
        return false;
      }
      return false;
    },
    getAccount() {
      return this.app.accounts.find((s) => s.accountId === this.conversation.accountId);
    },
    pinMessage(message) {
      this.$refs.pinComponents.pinMessage(message);
      message.visiblePopup = false;
    },
    copy(message) {
      let code = JSON.parse(message.content).title;
      const el = document.createElement("textarea");
      el.value = code;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      message.visiblePopup = false;
    },
    undoMessage(message) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        group: true,
        msgId: message.id.msgId,
        cliMsgIdUndo: message.cliMsgId,
      };
      message.visiblePopup = false;
      if (new Date().getTime() - Number(message.ts) > 24 * 60 * 60 * 1000) return this.alert("error", "Bạn chỉ có thể thu hồi tin nhắn trong vòng 24h");
      this.$http.post("/api/message/undo", request);
    },
    deleteMessage(message) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        group: true,
        cliMsgId: message.cliMsgId,
        globalMsgId: message.id.msgId,
        ownerId: message.id.uidFrom !== "0" ? message.id.uidFrom : this.conversation.accountId,
        destId: this.conversation.toId,
      };
      this.$http.post("/api/message/delete", request);
      message.visiblePopup = false;
    },
    isShowMessageSharePopup(message) {
      return (
        this.isShowListIcon(message) &&
        (message.msgType === "webchat" ||
          message.msgType === "chat.photo" ||
          message.msgType === COMMON.CHAT_FILE ||
          message.msgType === COMMON.CHAT_VIDEO ||
          this.isCardBusiness(message))
      );
    },
    showMessageSharePopup(message) {
      this.messageShare = message;
      this.showMessageShare = true;
    },
    detectURLs(message) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      return message.match(urlRegex);
    },
    createNewTopic() {
      if (this.topic.title.length == 0) {
        this.alert("error", "Nhập nội dung");
        return;
      }
      if (new Date(this.topic.startTime).getTime() === 0) {
        this.alert("error", "Bạn chưa chọn thời gian");
        return;
      }
      if (new Date(this.topic.startTime).getTime() < new Date().getTime()) {
        this.alert("error", "Nhập lại thời gian");
        return;
      }
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        startTime: new Date(this.topic.startTime).getTime(),
        title: this.topic.title,
        repeat: this.topic.repeat,
      };
      this.$http.post("/api/message/createGroupTopic", request);
      this.createTopic = false;
    },
    showCreatePopup() {
      this.topic = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        startTime: new Date(),
        title: "",
        repeat: 0,
      };
      this.createTopic = true;
    },
    showPhoto(message) {
      try {
        if (message.msgType == "chat.photo") {
          if (JSON.parse(message.content).params) {
            let params = JSON.parse(JSON.parse(message.content).params);
            if (params.is_group_layout) {
              if (params.id_in_group === 0) {
                return true;
              } else {
                let id = JSON.parse(JSON.parse(message.content).params).group_layout_id;
                let id_in_group = JSON.parse(JSON.parse(message.content).params).id_in_group;

                let idsInGroup = this.messageList
                  .filter((c) => {
                    if (c.msgType === "chat.photo") {
                      let params = JSON.parse(JSON.parse(c.content).params);
                      if (params.group_layout_id) {
                        return params.group_layout_id === id;
                      }
                    }
                    return false;
                  })
                  .map((s) => JSON.parse(JSON.parse(s.content).params).id_in_group);

                if (id_in_group === Math.min(...idsInGroup)) {
                  return true;
                } else {
                  return false;
                }
              }
            }
          }
        }
      } catch (e) {
        return true;
      }
      return true;
    },
    removeImage(index) {
      this.hovered = null;
      this.app.selectedImages.splice(index, 1);
    },
    showRepliedMessage(message) {
      this.showLink = false;
      this.showReplied = true;
      this.messageReplied = message;
      this.$nextTick(() => {
        this.$refs.chatMessageReply.style.height = this.HEIGHT_MESSAGE_REPLIED + "px";
        if (this.app.selectedImages.length > 0) {
          this.$refs.chatConversation.style.height = `calc(100vh - 196px- 23px - ${this.$refs.chatMessageReply.style.height} - ${
            this.HEIGHT_MESSAGE_PASTE + "px"
          })`;
        } else {
          this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px - ${this.$refs.chatMessageReply.style.height})`;
        }
        if (this.showChat) {
          this.$refs.inputText.focus();
        }
        this.calculatorPinMessageHeight();
      });
    },
    closeReplied() {
      this.messageReplied = {};
      this.showReplied = false;
      this.restoreHeightChatAfterReplied();
    },
    restoreHeightChatAfterReplied() {
      this.$nextTick(() => {
        if (this.app.selectedImages.length > 0) {
          this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px  -  ${this.HEIGHT_MESSAGE_PASTE + "px"})`;
          //   this.$refs.chatConversation.style.height = "calc(100vh - 246px)";
        } else {
          this.$refs.chatConversation.style.height = "calc(100vh - 196px - 23px)";
        }
        this.calculatorPinMessageHeight();
      });
      this.hoveredReplied = null;
    },
    replyMessage() {
      let message = this.messageReplied;
      let request = {
        conversationId: this.conversation.id,
        toId: this.conversation.toId,
        accountId: this.conversation.accountId,
        message: this.newMessage,
        ownerId: message.id.uidFrom != "0" ? message.id.uidFrom : this.conversation.accountId,
        replyMsgId: message.id.msgId,
        replyMsgClientId: message.cliMsgId,
        replyMsgTs: message.ts,
      };

      let url;
      if (message.msgType === "webchat") {
        request.replyMsg = message.content;
        url = "/api/message/replyGroupMessage";
      } else if (message.msgType === "chat.photo") {
        let content = JSON.parse(message.content);
        content.oriUrl = content.hdUrl = content.normalUrl = content.href;
        content.thumbUrl = content.thumb;

        request.replyMsgAttach = content;
        request.group = true;

        url = "/api/message/replyPhoto";
      } else if (this.isLinkMessage(message)) {
        url = "/api/message/replyPhoto";
        let content = JSON.parse(message.content);
        content.type = "38";
        request.replyMsgAttach = content;
        request.group = true;
      }

      this.$http
        .post(url, request)
        .then(() => {})
        .catch(() => {
          this.alert("error", "Có lỗi xảy ra ");
        })
        .finally(() => {});

      this.showReplied = false;
      this.newMessage = "";
      this.restoreHeightChatAfterReplied();
    },
    copyFile(e) {
      // Handle the event
      this.retrieveImageFromClipboardAsBlob(
        e,
        function (imageBlob) {
          // If there's an image, display it in the canvas
          if (imageBlob) {
            // Crossbrowser support for URL
            var URLObj = window.URL || window.webkitURL;
            var url = URLObj.createObjectURL(imageBlob);
            var image = {
              file: imageBlob,
              url: url,
            };

            if (this.app.selectedImages) this.app.selectedImages.push(image);
            else {
              this.app.selectedImages = [];
              this.app.selectedImages.push(image);
            }
          }
        }.bind(this)
      );
    },

    isLockSendMsg() {
      if (this.settingGroup.lockSendMsg === 0) {
        return false;
      } else return !this.settingGroup.adminIds.includes(this.conversation.accountId);
    },
    retrieveImageFromClipboardAsBlob(pasteEvent, callback) {
      if (pasteEvent.clipboardData == false) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }

      var items = pasteEvent.clipboardData.items;

      if (items == undefined) {
        if (typeof callback == "function") {
          callback(undefined);
        }
      }

      for (var i = 0; i < items.length; i++) {
        // Skip content if not image
        // if (items[i].type.indexOf("image") == -1) continue;
        // Retrieve image on clipboard as blob
        var blob = items[i].getAsFile();

        if (typeof callback == "function") {
          callback(blob);
        }
      }
    },
    calculatorHeightMessage() {
      if (this.showReplied) {
        if (this.app.selectedImages.length === 0) {
          this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px - ${this.$refs.chatMessageReply.style.height} )`;
          this.calculatorPinMessageHeight();
          return;
        }
        if (this.app.selectedImages.length > 1) return;
        this.$refs.chatMessageReply.style.height = this.HEIGHT_MESSAGE_REPLIED + "px";
        this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px - ${this.$refs.chatMessageReply.style.height} - ${
          this.HEIGHT_MESSAGE_PASTE + "px"
        })`;
        this.calculatorPinMessageHeight();
      } else {
        if (this.app.selectedImages.length === 0) {
          this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px)`;
          this.calculatorPinMessageHeight();
          return;
        }
        // if (this.app.selectedImages.length > 1) return;
        this.$refs.chatConversation.style.height = `calc(100vh - 196px - 23px - ${this.HEIGHT_MESSAGE_PASTE + "px"})`;
        this.calculatorPinMessageHeight();
      }
    },
    recordScrollPosition() {
      let node = this.$refs["scrollContainer"];
      this.previousScrollHeightMinusScrollTop = node.scrollHeight - node.scrollTop;
    },
    restoreScrollPosition() {
      let node = this.$refs["scrollContainer"];
      node.scrollTop = node.scrollHeight - this.previousScrollHeightMinusScrollTop;
    },
    setUpInterSectionObserver() {
      let options = {
        root: this.$refs["scrollContainer"],
        margin: "10px",
      };
      this.listEndObserver = new IntersectionObserver(this.handleIntersection, options);

      this.listEndObserver.observe(this.$refs["sentinel"]);
    },
    handleIntersection([entry]) {
      if (entry.isIntersecting && this.canLoadMore) {
        this.loadMore();
      }
    },

    async loadMore() {
      this.recordScrollPosition();
      await this.fetchMessageList();

      this.$nextTick(() => {
        setTimeout(() => {
          this.restoreScrollPosition();
        }, 0);
      });
    },
    async fetchMessageList() {
      await this.$http
        .post("/api/message/filter", {
          conversationId: this.conversation.id,
          accountId: this.conversation.accountId,
          timestamp: this.nextTime,
          pageSize: this.PAGE_SIZE,
        })
        .then((resp) => {
          try {
            if (resp.data.length > 0) {
            resp.data.forEach((s) => (s.visiblePopup = false));
            this.messageList.unshift(...resp.data.reverse());
            this.sortMessage("new");
            this.nextTime = resp.data[0].ts;
          }
          if (this.PAGE_SIZE !== resp.data.length) {
            this.canLoadMore = false;
          }
          this.handleAlias(resp.data);
          this.convertToDoMessage(this.messageList);
          } catch (e) {
            console.log("🚀 ~ .then ~ e:", e)
          }

        });
    },
    async crawlMessageList() {
      let resp = await this.$http.post("/api/message/crawl", {
        conversationId: this.conversation.id,
        accountId: this.conversation.accountId,
        timestamp: this.nextTime,
        pageSize: this.PAGE_SIZE,
      });
      if (resp.data.length > 0) {
        resp.data.forEach((s) => (s.visiblePopup = false));
        this.messageList = resp.data.reverse();
        this.nextTime = resp.data[0].ts;
      }
      if (this.PAGE_SIZE !== resp.data.length) {
        this.canLoadMore = false;
      }
    },
    initializaInterSectionObserver(ms = 0) {
      setTimeout(() => {
        this.$nextTick().then(() => {
          let scrollContainer = this.$refs["scrollContainer"];
          if (scrollContainer !== undefined) {
            scrollContainer.scrollTop = scrollContainer.scrollHeight;
            this.$nextTick().then(() => {
              this.setUpInterSectionObserver();
            });
          }
        });
      }, ms);
    },
    async getInitializationMessages() {
      if (this.canLoadMore) {
        await this.fetchMessageList();
        this.unread(this.conversation.id);
        if (this.messageList.filter((s) => s.msgType === "webchat").length > 20) {
          this.initializaInterSectionObserver(100);
        } else {
          this.initializaInterSectionObserver(500);
        }
      }
    },

    isEmptyObject(item) {
      return Object.keys(item).length === 0;
    },
    resetLinkDefault() {
      this.showLink = false;
      this.linkObject = {};
    },
    splitWhiteSpace(item) {
      return item.split(/\s+/);
    },
    handleLink() {
      this.newMessage = this.newMessage.trimStart();
      if (this.showReplied) return this.resetLinkDefault();

      let arrLinks = this.detectURLs(this.newMessage);
      if (arrLinks == null) return this.resetLinkDefault();

      let arrsSplit = this.splitWhiteSpace(this.newMessage);
      if (arrsSplit.length === 1 && arrLinks[0] === this.newMessage && this.isEmptyObject(this.linkObject)) return this.parseLink(arrLinks[0]);
      if (arrsSplit.length > 1) {
        let index = arrsSplit.indexOf(arrLinks[0]);
        if (arrsSplit[index + 1] !== undefined) {
          if (this.isEmptyObject(this.linkObject)) return this.parseLink(arrLinks[0]);
          if (![this.linkObject.href, this.linkObject.src].includes(arrLinks[0].trim())) return this.parseLink(arrLinks[0]);
        }
      }
    },
    parseLink(link) {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        link: link,
      };
      this.$http.post("/api/message/parseLink", request).then((resp) => {
        if (Object.keys(resp.data).length > 0) {
          this.linkObject = resp.data.data;
          this.showLink = true;
        } else {
          this.resetLinkDefault();
        }
      });
    },
    sendLink(item) {
      if (item.title !== undefined && item.title.length === 0) {
        this.sendTextMessage();
        this.newMessage = "";
        this.showLink = false;
        this.linkObject = {};
        return;
      }
      let request = {
        conversationId: this.conversation.id,
        group: true,
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        media: JSON.stringify(item.media),
        desc: item.desc,
        href: item.href,
        src: item.src,
        thumb: item.thumb,
        title: item.title,
        link: this.newMessage,
      };
      this.$http.post("/api/message/sendLink", request).finally(() => {
        this.newMessage = "";
        this.showLink = false;
        this.linkObject = {};
      });
    },
    handleInput() {
      this.getQuickMessage();
      this.handleLink();
      this.getMentionComponent();
      this.filterCharacter();
      this.app.listDraft.set(this.conversation.id, this.newMessage);
    },
    filterCharacter() {
      let items = [];

      let check = true;
      let fil = this.app.accountSetting.filter((p) => p.accountId == this.conversation.accountId);
      if (fil != null && fil.length > 0) {
        check = fil[0].checkBadWord;
      }
      if (check) {
        let text = this.newMessage;
        let arr = text.split(" ");
        if (this.filterCharacterArr && this.filterCharacterArr.length > 0 && arr.length > 0) {
          for (let item of this.filterCharacterArr) {
            arr.forEach((it) => {
              if (it.toLowerCase() == item.content.toLowerCase()) {
                let fil = items.filter((f) => f.key == it);
                if (fil == null || fil.length == 0) {
                  items.push({ key: it, replace: "****" });
                }
              }
            });
          }
        }
      }
      return items;
    },
    getQuickMessage() {
      this.showQuickMessage = false;
      if (this.newMessage.startsWith("/") && this.app.quickReplyList.length > 0) {
        this.showQuickMessage = true;
        let quickStart = this.app.quickReplyList.filter((item) => ("/" + item.code).startsWith(this.newMessage));
        if (quickStart != null && quickStart.length == 1) {
          this.newMessage = quickStart[0].content + " ";
          this.pushSelectImages(quickStart[0]);
          this.showQuickMessage = false;
        } else {
          let quick = this.app.quickReplyList.filter((item) => "/" + item.code + " " == this.newMessage);
          if (quick != null && quick.length == 1) {
            this.newMessage = quick[0].content + " ";
            this.pushSelectImages(quick[0]);
            this.showQuickMessage = false;
          }
        }
      }
    },

    selectMessage(message) {
      this.newMessage = message.content;
      this.showQuickMessage = false;
      this.pushSelectImages(message);
    },
    handlePinMessageFromWebHook(message) {
      try {
        if (message.msgType === COMMON.WEBCHAT && this.isJsonString(message.content)) {
          let content = JSON.parse(message.content);
          if (content.action !== "msginfo.actionlist") return;
          let params = JSON.parse(content.params);
          let actions = params.actions[0];
          if (actions === undefined || actions === null) {
            return this.getPinList();
          }
          let actionType = actions.actionType;
          if ([COMMON.PIN_MESSAGE, COMMON.UNPIN_MESSAGE, COMMON.ACTION_OPEN_PINBOARD].includes(actionType)) {
            this.getPinList();
          }
        }
      } catch (err) {
        // do somthing
      }
    },
    addMessage(message) {
      if (message.id.conversationId == this.conversation.id) {
        let filter = this.messageList.filter((m) => m.cliMsgId == message.cliMsgId && m.id.msgId === message.id.msgId);
        if (filter != null && filter.length > 0) {
          let index = this.messageList.indexOf(filter[0]);
          if (index > -1) {
            this.messageList.splice(index, 1);
          }
        }
        this.handleTodoMessageFromWebhook(message, this.messageList);
        this.messageList.push(message);
        let clientMsgId = null;
        try {
          if (message.msgType == "chat.delete") {
            let item = JSON.parse(message.content)[0];
            clientMsgId = item.clientDelMsgId;
          }
          if (message.msgType == "chat.undo") {
            let item = JSON.parse(message.content);
            clientMsgId = item.cliMsgId;
          }
        } catch (ex) {
          //
        }
        this.sortMessage("new", clientMsgId);
        // this.messageList = this.messageList.sort((a, b) => Number(a.ts) - Number(b.ts));
        this.handlePinMessageFromWebHook(message);

        if (message.id.uidFrom === "0") {
          this.scrollImmediately();
        }
        // else if (message.msgType !== "webchat" && message.id.uidFrom == "0") {
        //   this.scrollBottom(200);
        // }

        if (message.id.uidFrom !== "0") {
          let scrollContainer = this.$refs["scrollContainer"];
          if (scrollContainer.scrollTop < scrollContainer.scrollHeight - scrollContainer.clientHeight - 40) {
            this.showIconNewMessage = true;
          } else {
            this.scrollImmediately();
          }
        }

        if (this.showIconNewMessage === false) this.unread(this.conversation.id);
      }
    },
    getCount() {
      return this.members.length;
    },
    async getGroupInfo() {
      this.isRemove = false;
      this.members = [];
      this.$http
        .get("/api/message/groupInfoV2", {
          params: {
            accountId: this.conversation.accountId,
            groupId: this.conversation.toId,
          },
        })
        .then(async (resp) => {
          let gridInfoMap = resp.data.data?.gridInfoMap[this.conversation.toId];
          gridInfoMap.memberVerMap = {};
          gridInfoMap.memVerList.forEach((i) => {
            let parts = i.split("_");
            gridInfoMap.memberVerMap[parts[0]] = parts[1];
          });
          let memberMap;
          if (gridInfoMap !== undefined) {
            memberMap = gridInfoMap.memberVerMap;
            this.settingGroup = gridInfoMap.setting;
            this.settingGroup.adminIds = gridInfoMap.adminIds;
            this.settingGroup.adminIds.push(gridInfoMap.creatorId);
          }
          if (resp.data.data?.removedsGroup.length > 0) {
            this.isRemove = true;
            this.alert("error", "Bạn đã rời khỏi nhóm này");
          }
          let newMemberMap = {};
          if (memberMap === {} || memberMap === null) return;
          for (const key of Object.keys(memberMap)) {
            let item = this.app.aliases.find((s) => s.id == key && this.conversation.accountId == s.accountId);
            if (item) {
              this.members.push(item);
            } else {
              newMemberMap[key] = memberMap[key];
            }
          }

          if (Object.keys(newMemberMap).length > 498) {
            const chunkSize = 498;
            for (let i = 0; i < Object.keys(newMemberMap).length; i += chunkSize) {
              let data = Object.fromEntries(Object.entries(newMemberMap).slice(i, i + chunkSize));
              this.getMembers(data);
            }
          } else {
            this.getMembers(newMemberMap);
          }
        });
    },

    getMembers(memberMap) {
      if (Object.keys(memberMap).length === 0) return;
      let request = {
        memberMap: memberMap,
        accountId: this.conversation.accountId,
      };

      this.$http.post("/api/conversation/groupMember", request).then((resp) => {
        if (resp.data && resp.data.length > 0) {
          this.members.push(...resp.data);
          resp.data.forEach((s) => {
            if (!this.app.aliases.find((a) => a.accountId === this.app.selectedConversation.accountId && s.id === a.id)) {
              this.app.aliases.push(s);
            }
          });
        }
      });
    },

    getMember(id) {
      return this.members.find((m) => m.id == id) ? this.members.find((m) => m.id == id) : { avatar: "" };
    },

    sendFileClipborad() {
      let urlsFromQuickMessage = this.app.selectedImages.filter((s) => !s.file).map((s) => s.url);
      if (this.app.selectedImages.length === 1) {
        if (urlsFromQuickMessage.length === 1) {
          this.sendMsgPhoto(null, 0, 0, 0, this.getIdFromUrl(urlsFromQuickMessage[0]));
        } else {
          this.sendMsgFile(this.app.selectedImages[0].file, 0, 0, 0);
        }
      }
      if (this.app.selectedImages.length > 1) {
        let groupId = new Date().getTime();
        for (let i = 0; i < this.app.selectedImages.length; i++) {
          let totalItems = this.app.selectedImages.length;
          let s = this.app.selectedImages[i];
          if (s.file) {
            this.sendMsgFile(s.file, groupId, totalItems, i);
          } else {
            this.sendMsgPhoto(null, groupId, totalItems, i, this.getIdFromUrl(s.url));
          }
        }
      }
      this.app.selectedImages = [];
    },
    sendReplace() {
      this.newMessage = this.replaceBadWord.content;
      this.sendMesV2(
        this.replaceBadWord.items.map((k) => {
          return k.key;
        }),
        true
      );
      this.closeReplaceBadWord();
    },
    closeReplaceBadWord() {
      this.replaceBadWord.show = false;
    },
    handleInputReplace() {
      this.replaceBadWord.items.forEach((it) => {
        for (let item of this.filterCharacterArr) {
          if (it.replace.toLowerCase() == item.content.toLowerCase()) {
            it.replace = "****";
          }
        }
      });
      this.replaceBadWordContent();
    },
    deleteReplace(item) {
      let filter = this.replaceBadWord.items.filter((con) => con.key == item.key);
      if (filter != null && filter.length > 0) {
        const index = this.replaceBadWord.items.indexOf(filter[0]);
        if (index > -1) {
          this.replaceBadWord.items.splice(index, 1);
          this.replaceBadWordContent();
        }
      }
    },
    replaceBadWordContent() {
      this.replaceBadWord.content = this.newMessage;
      this.replaceBadWord.items.forEach((item) => {
        this.replaceBadWord.content = this.replaceBadWord.content.replaceAll(item.key, item.replace);
      });
    },
    sendTextMessage() {
      if (this.newMessage.length > 0) {
        let items = this.filterCharacter();
        if (items.length > 0) {
          this.replaceBadWord.show = true;
          this.replaceBadWord.items = items;
          this.replaceBadWordContent();
        } else {
          this.sendMesV2();
        }
      }
    },
    sendMesV2(keys, replace) {
      let request = {
        accountId: this.conversation.accountId,
        groupId: this.conversation.toId,
        message: this.newMessage.trim(),
        bannedKeyword: keys ? keys : [],
        replace: replace,
      };
      this.newMessage = "";
      this.$http.post("/api/message/groupMsg", request);
      this.handleDraftMessage(this.newMessage, this.conversation.id);
    },
    sendMessage(event) {
      event.preventDefault();
      if (!this.newMessage.trim().length && this.app.selectedImages.length === 0) return this.alert("error", "Nhập nội dung cần gửi.");
      if (this.showReplied) {
        if (this.newMessage.trim().length > 0) this.replyMessage();
        if (this.app.selectedImages.length > 0) this.sendFileClipborad();
        return (this.showReplied = false);
      }
      if (this.newMessage.trim().length > 0) {
        if (Object.keys(this.linkObject).length > 0 && this.showLink) {
          this.sendLink(this.linkObject);
        } else {
          if (this.refactorListMentions().length > 0) {
            return this.mentioned();
          }
          this.sendTextMessage();
        }
      }

      if (this.app.selectedImages.length > 0) this.sendFileClipborad();
    },

    fileSelected() {
      let groupMsgId = new Date().getTime();
      let totalItems = this.$refs.file.files.length;
      if (totalItems === 1) {
        return this.sendMsgFile(this.$refs.file.files[0], 0, 0, 0);
      }
      this.$refs.file.files.forEach(async (item, index) => {
        await this.sendMsgFile(item, groupMsgId, totalItems, index);
      });
      this.$refs.file.value = null;
    },
    async fetchAllTag() {
      let resp = await this.$http.get("/api/tag");
      this.tags = resp.data;
    },
    sendMsgPhoto(file, groupMsgId, totalItems, index, idFromQuickMessage) {
      if (file && this.hasErrorSendFile(file)) return;
      var bodyFormData = new FormData();
      bodyFormData.append("file", file);
      bodyFormData.append("accountId", this.conversation.accountId);
      bodyFormData.append("groupId", this.conversation.toId);
      if (idFromQuickMessage) {
        bodyFormData.append("id", idFromQuickMessage);
      }
      this.$http.post("/api/message/sendGroupMsgPhoto?groupMsgId=" + groupMsgId + "&totalItems=" + totalItems + "&idInGroup=" + index, bodyFormData);
    },
    async sendMsgFile(file, groupMsgId, totalItems, index) {
      if (this.hasErrorSendFile(file)) return;
      if (["image/png", "image/jpeg", "image/svg", "image/gif"].includes(file["type"])) {
        await this.sendMsgPhoto(file, groupMsgId, totalItems, index);
      } else {
        var bodyFormData = new FormData();
        bodyFormData.append("conversationId", this.conversation.id);
        bodyFormData.append("file", file);
        bodyFormData.append("accountId", this.conversation.accountId);
        bodyFormData.append("toId", this.conversation.toId);
        bodyFormData.append("isGroup", true);

        await this.sendFile(file, bodyFormData);
      }
    },
    checkTyping(val, e) {
      if (e.type == "input" && val.length > 0 && !this.typing) {
        this.typing = true;
        this.sendTypingSocket("typing");
      }
    },
    unlockTyping(val) {
      if (val.length == 0) {
        this.sendTypingSocket("stopped_typing");
        this.typing = false;
      }
    },
    sendTypingSocket(type) {
      let request = {
        accountId: this.conversation.accountId,
        conversationId: this.conversation.id,
        type: type,
        username: this.app.user.swUsername,
      };
      this.$http.post("/api/conversation/typing", request);
    },
    sendBy(data) {
      if (data.accountId == this.conversation.accountId && data.toId == this.conversation.toId) {
        this.sortMessage("sendBy");
      }
    },
    replaceNew(data) {
      if (data.conversationId == this.conversation.id) {
        this.sortMessage("replace");
      }
      // this.replaceUrl.push(data);
    },
    reactionNew(data) {
      this.reactionList.push(data);
    },

    getPinList() {
      let request = {
        accountId: this.conversation.accountId,
        toId: this.conversation.toId,
        group: true,
      };
      this.$http.post("/api/conversation/pinMsgList", request).then((resp) => {
        this.pinMessages = [];
        let items = resp.data?.data.items;
        if (items === undefined) return;
        items.forEach((item) => {
          let params = JSON.parse(item.params);
          params.id = item.id;
          params.type = item.type;
          params.visible = false;
          this.pinMessages.push(params);
        });
        if (this.pinMessages.length === 0) this.removeOverScreen();
      });
    },
    getNewMessageHistory() {
      if (this.app.listDraft.has(this.conversation.id)) {
        this.newMessage = this.app.listDraft.get(this.conversation.id);
      } else {
        this.newMessage = "";
      }
    },
    EmojiPickup(emoji) {
      this.newMessage = this.newMessage.concat(emoji);
    },
  },
  async mounted() {
    this.newMessage = this.getDraftMessageHistory(this.conversation.id);
    // this.getNewMessageHistory();
    // this.newMessage = this.app.listDraft.get(this.conversation.id);
    this.$refs.chatConversation.style.height = "calc(100vh - 196px - 23px)";
    if (this.showChat) {
      this.$refs.inputText.focus();
    }
    this.getPinList();
    await this.getGroupInfo();
    this.getInitializationMessages();
  },
  created() {
    this.app.selectedImages = [];
    window.addEventListener("paste", this.copyFile, false);
    this.$bus.$on("closeDialogMember", () => {
      this.members = [];
      this.getGroupInfo();
    });
    this.$bus.$on("sendByEvent", (data) => {
      this.sendBy(data);
    });
    this.$bus.$on("ReplaceLinkEvent", (data) => {
      this.replaceNew(data);
    });
    this.$bus.$on("zaloReaction", (data) => {
      this.reactionNew(data);
    });
    this.fetchAllTag();
    this.$bus.$once("syncMessageEmit", async () => {
      this.nextTime = null;
      this.messageList = [];
      this.crawlMessageList().then(() => {
        if (this.messageList.filter((s) => s.msgType === "webchat").length > 20) {
          this.initializaInterSectionObserver(100);
        } else {
          this.initializaInterSectionObserver(500);
        }
      });
    });
    this.$bus.$on("emoji_click", (data) => {
      this.EmojiPickup(data);
    });
  },
  beforeDestroy() {
    this.$bus.$off("closeDialogMember");
    this.handleDraftMessage(this.newMessage, this.conversation.id);
    window.removeEventListener("paste", this.copyFile, false);
    this.pinMessages = [];
    this.messageList = [];
    this.replaceUrl = [];
    this.tags = [];
    this.pinMessages = [];
    this.sendByList = [];
  },
};
</script>

<style scoped>
.msg-input {
  height: 80px;
}
</style>
